import { defineComponent as _defineComponent } from 'vue'
import { THGUser } from '@/interfaces/thg/THGUser';
    import { computed } from 'vue';
    import { THGUserType } from '@/enums/thg/THGUserType';
    import { getUserTypeText } from '@/utils/thg';
    import THGDonationProjectsCheckboxGroup from '@/components/thg/user/THGDonationProjectsCheckboxGroup.vue';
    import { useTHGGlobalStore } from '@/storenew/thg/global';
    import { Country } from '@/enums/Country';
    import THGTagInput from '@/components/thg/THGTagInput.vue';

    interface Props {
        value: THGUser;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGUserForm',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'input', user: THGUser): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        value: THGUser;
    };

    const { currentCountry } = useTHGGlobalStore();

    

    

    // the vat number (UID) is only required for companies which are liable to tax
    const isVatNumberRequired = computed(
        () => user.value.type === THGUserType.COMPANY && !!user.value.liable_tax,
    );

    // event from child component, update the projects
    const onProjectsUpdated = (projects: string[]) => {
        user.value.donation_projects = projects;
    };

    const user = computed<THGUser>({
        get() {
            return props.value;
        },
        set(newVal: THGUser) {
            emit('input', newVal);
        },
    });

return { __sfc: true,currentCountry, props, emit, isVatNumberRequired, onProjectsUpdated, user, THGUserType, getUserTypeText, THGDonationProjectsCheckboxGroup, Country, THGTagInput }
}

})